// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NWZHwHT5pqU0ts5MOzFl{flex-direction:column;gap:8px;width:100%;display:flex;overflow:auto}.zxkpRvj9MzosMEjV4fck{word-wrap:break-word;-webkit-line-clamp:3;line-clamp:3;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `NWZHwHT5pqU0ts5MOzFl`,
	"text": `zxkpRvj9MzosMEjV4fck`
};
export default ___CSS_LOADER_EXPORT___;
